import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Screen } from "../components/Screen";
import { LoadingScreen } from "../components/LoadingScreen";
import { Button } from "../components/Button";
import { useQuiz } from "../features/quiz/QuizContext";
import styles from "./ResultScreen.module.css";

export function ResultScreen() {
  const navigate = useNavigate();
  const { scoreResult, reset } = useQuiz();

  // Redirect from an effect, not the render body: navigating during render
  // (with no scheduled re-render to guarantee the change actually commits)
  // could leave the screen permanently blank on a direct/refreshed load —
  // e.g. hitting /result with no in-memory score after a hard refresh.
  useEffect(() => {
    if (!scoreResult) navigate("/", { replace: true });
  }, [scoreResult, navigate]);

  if (!scoreResult) {
    return <LoadingScreen />;
  }

  const hasMistakes = scoreResult.mistakeQuestionIds.length > 0;

  return (
    <Screen>
      <div className={styles.wrap}>
        <div className={styles.eyebrow}>Результат</div>

        <div className={styles.scoreRow}>
          <span className={styles.score}>
            {scoreResult.score} / {scoreResult.total}
          </span>
          <span className={styles.percentage}>{scoreResult.percentage}%</span>
        </div>

        {scoreResult.strongTopics.length > 0 && (
          <div className={styles.section}>
            <span className={styles.sectionTitle}>Сильные стороны</span>
            <div className={styles.topicList}>
              {scoreResult.strongTopics.map((t) => (
                <span key={t} className={styles.chip}>
                  {t}
                </span>
              ))}
            </div>
          </div>
        )}

        {scoreResult.weakTopics.length > 0 && (
          <div className={styles.section}>
            <span className={styles.sectionTitle}>Требует внимания</span>
            <div className={styles.topicList}>
              {scoreResult.weakTopics.map((t) => (
                <span key={t} className={styles.chip}>
                  {t}
                </span>
              ))}
            </div>
          </div>
        )}

        <div className={styles.actions}>
          {hasMistakes && (
            <Button
              onClick={() => {
                navigate("/mistakes");
              }}
            >
              Разобрать ошибки
            </Button>
          )}
          <Button
            variant="secondary"
            onClick={() => {
              reset();
              navigate("/");
            }}
          >
            Новый тест
          </Button>
        </div>
      </div>
    </Screen>
  );
}
